import { render } from "./TextReaderCiudad.vue?vue&type=template&id=596039b0"
import script from "./TextReaderCiudad.vue?vue&type=script&lang=js"
export * from "./TextReaderCiudad.vue?vue&type=script&lang=js"

import "./TextReaderCiudad.vue?vue&type=style&index=0&id=596039b0&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__